import React from 'react';

function Study() {
  return (
    <div className="max-w-4xl mx-auto py-2 lg:py-8">
      {/* Desktop Header - hidden on mobile */}
      <div className="hidden lg:flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Study</h1>
      </div>

      {/* Mobile Header - compact */}
      <div className="lg:hidden flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold text-gray-900">Study</h1>
      </div>

      <div className="card">
        <div className="text-center py-12">
          <div className="mb-4">
            <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">Study Features Coming Soon</h3>
          <p className="text-gray-600">
            Bible study tools, notes, and reading plans will be available in a future update.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Study;
